import type { Country, Resort } from '@/shared/model';

/**
 * Находит страну по id среди уже выбранной или в переданном списке; если её там нет —
 * строит плейсхолдер с fallback-именем. Общая логика desktop- и mobile-ядер поля «Куда».
 */
export function resolveCountryFromList(
  countryId: number,
  fallbackName: string,
  selected: Country | null,
  known: Country[],
): Country {
  if (selected && selected.id === countryId) {
    return selected;
  }
  const match = known.find((country) => country.id === countryId);
  if (match) {
    return match;
  }
  return {
    id: countryId,
    name: fallbackName,
    isPopular: false,
    position: null,
    visaRequired: false,
    visaOnline: false,
    visaDays: null,
    minPrice: null,
  };
}

/**
 * Каталог курортов страны: возвращает загруженный кэш, если он относится к этой стране,
 * иначе — резорты из самой страны. Общая логика desktop- и mobile-ядер поля «Куда».
 */
export function countryResortCatalog(country: Country, cached: Resort[]): Resort[] {
  if (cached.length > 0 && cached[0].countryId === country.id) {
    return cached;
  }
  return country.resorts ?? [];
}
